import React from "react";
import { CardComp } from "../../../components";
import {
  useGetMemberBirthdayVisibilityQuery,
  useUpdateMemberBirthdayVisibilityMutation,
} from "../../../store/member/memberBirthdaySlice";
import { toast } from "react-hot-toast";
import Loader from "../../../components/Ui/Loader";

const PrivacyTab = () => {
  const { data: visibilityData, isLoading } = useGetMemberBirthdayVisibilityQuery();
  const [updateVisibility, { isLoading: isUpdating }] = useUpdateMemberBirthdayVisibilityMutation();

  const handleToggle = async (e) => {
    const isVisible = e.target.checked;
    try {
      const response = await updateVisibility({ is_visible: isVisible }).unwrap();
      if (response.status) {
        toast.success(`Birthday visibility ${isVisible ? "enabled" : "disabled"}`);
      } else {
        toast.error(response.message || "Failed to update visibility");
      }
    } catch (error) {
      toast.error("An error occurred while updating visibility");
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Loader />
      </div>
    );
  }

  return (
    <div className="space-y-4 py-3">
      <CardComp cardClassName="rounded-4 border shadow-none bg-light">
        <div className="d-flex align-items-center justify-content-between p-3">
          <div className="flex-1 pe-4">
            <h6 className="fw-bold text-black2 mb-1">Birthday Visibility</h6>
            <p className="text-blacklight mb-0 small leading-relaxed">
              When enabled, other members can see your birthday on their dashboard and send you celebratory wishes. Your age is never shown.
            </p>
          </div>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="birthday_visibility"
              checked={visibilityData?.is_visible ?? true}
              onChange={handleToggle}
              disabled={isUpdating}
              style={{
                width: "3em",
                height: "1.5em",
                cursor: "pointer",
              }}
            />
          </div>
        </div>
      </CardComp>

      <div className="mt-4 p-3 rounded-4 bg-light border border-dashed text-blacklight small">
        <h6 className="fw-bold mb-2">Privacy Information</h6>
        <p className="mb-0">
          UniqueCoop values your privacy. We only show your name and membership number to other members during your birthday. No other personal information like phone number, email, or exact birth year is ever shared.
        </p>
      </div>
    </div>
  );
};

export default PrivacyTab;

